type FormatMessage = (descriptor: { defaultMessage: string }) => string;

export const getClaimabilityError = (
  reason: string | undefined,
  formatMessage: FormatMessage,
): string => {
  const normalized = reason?.toLowerCase() ?? '';

  if (normalized.includes('not registered')) {
    return formatMessage({ defaultMessage: 'Kortnumret hittas inte' });
  }
  if (normalized.includes('credit')) {
    return formatMessage({
      defaultMessage: 'Kortet användas redan för tjänsteresa på kort',
    });
  }
  if (normalized.includes('already claimed')) {
    return formatMessage({
      defaultMessage: 'Kortet är redan kopplat till en resenär',
    });
  }
  if (normalized.includes('eligible') || normalized.includes('usable')) {
    return formatMessage({
      defaultMessage:
        'Kort kan inte hanteras ännu. Resenären är inte klar för korthantering.',
    });
  }
  if (reason) {
    return reason;
  }
  return formatMessage({
    defaultMessage: 'Kortet är inte giltigt som resekort',
  });
};
